import OpusLayerGroup from "lib/classes/opuslayergroup";

interface LayerProps {
	id:string,
	name:string,
	legendOrder:number,
	cartographicOrder:number,
	isHidden:boolean,
	images:string[],
	group:OpusLayerGroup,
	visible?:boolean
}

/**
	* OpusMaps map layer class
	* 
	* @remarks
	* Used mainly in views/MapLayerTool
	* 
	* @param id				-	ID of the map layer
	* @param name			-	Name of the layer
	* @param isHidden		-	Visibility of map layer
	* @param images			-	Array of urls for the layer image
	* @param group			-	Associated map layer group
	* @param tileLayer		-	Associated OpenLayers tile layer
*/
export default class OpusLayer {
	public id:string;
	public name:string;
	public legendOrder:number;
	public cartographicOrder:number;
	public isHidden:boolean;
	public images:string[];
	public group:OpusLayerGroup;
	public _visibleInLegendOMV:boolean = false;
	
	private visible:boolean = true;
	
	constructor({id, name, legendOrder, cartographicOrder, isHidden, images, group, visible}:LayerProps) {
		this.id = id;
		this.name = name;
		this.legendOrder = legendOrder;
		this.cartographicOrder = cartographicOrder;
		this.isHidden = isHidden;
		this.images = images;
		this.group = group;
		this.visible = visible ?? true;
	}
	public setVisible(visible:boolean, callEvent:boolean = true) {
		// Hidden layers in the legend are always visible on the map
		if(this.isHidden) visible = true;
		
		this.visible = visible;
		this.group.updateAllVisible();
		
		callEvent && _events.invoke("layer-toggled", this);
	}
	public getVisible():boolean {
		return this.visible;
	}
}